<script setup>
import { computed, nextTick, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  response: { type: [Object, Array, String, Number, Boolean], required: true },
});

const emit = defineEmits(['close']);
const { t } = useI18n();
const dialogRef = ref(null);
const formattedResponse = computed(() =>
  JSON.stringify(props.response, null, 2)
);

nextTick(() => dialogRef.value?.open?.());
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="3xl"
    :title="t('CORTEX.TOOLS.FORM.TEST_RESULT_TITLE')"
    :description="t('CORTEX.TOOLS.FORM.TEST_RESULT_DESCRIPTION')"
    :show-confirm-button="false"
    :show-cancel-button="false"
    @close="emit('close')"
  >
    <div
      class="max-h-[calc(100vh-18rem)] overflow-auto whitespace-pre-wrap rounded-lg bg-n-alpha-2 p-4 font-mono text-xs leading-relaxed text-n-slate-12"
    >
      {{ formattedResponse }}
    </div>
    <template #footer>
      <div class="flex justify-end">
        <NextButton
          sm
          outline
          slate
          icon="i-lucide-x"
          :label="t('CORTEX.TOOLS.FORM.CLOSE_TEST_RESULT')"
          @click="dialogRef?.close?.()"
        />
      </div>
    </template>
  </Dialog>
</template>
